// скролл к чему-то

import { isMobile, isTablet, isDesktop } from "../../functions/check-viewport";
import $ from 'jquery';
function scrollTo() {
  const Btn = document.querySelector('.sectionOne__arrow');
  const section = document.getElementById('sectionTwo')
  Btn.addEventListener('click', ()=> {

    if (isMobile()) {
      section.scrollIntoView({
        behavior: "smooth"
      })
    }
   if (isDesktop() || isTablet()) {
     let height = $(window).height();
     $(window).scrollTop(height);
   }
  })
}

export  {
  scrollTo
}
